export default {
  description:
    'Upload de documenten die we nodig hebben om je bedrijf te verifiëren. Verplichte documenten zijn gemarkeerd; optionele kun je nu of later toevoegen.',
  missing_one:
    'Er ontbreekt nog een verplicht document. Je kunt doorgaan: deze stap blijft open totdat het geüpload is.',
  missing_other:
    'Er ontbreken nog {{count}} verplichte documenten. Je kunt doorgaan: deze stap blijft open totdat ze geüpload zijn.',
  buttons: {
    back: 'Terug',
    next: 'Volgende',
    finish_later: 'Later voltooien',
  },
};
